import React, { memo, useMemo } from 'react';
import useSource from './use-source';
import resolvePlugins from './resolve-plugins';

const withPlugins = (...plugins) => WrapperComponent => {
  const HighOrderComponent = memo(props => {
    const source = useSource(plugins, props);
    const matchedPlugins = useMemo(() => resolvePlugins(source, plugins), [source]);
    return <WrapperComponent {...props} plugins={matchedPlugins} />;
  });

  HighOrderComponent.displayName = `withPlugins(${WrapperComponent.displayName})`;
  return HighOrderComponent;
};

export default withPlugins;
